/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses.
 */

jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};

        if (j === null) {
            j = "";
            m.expires = -1;
        }

        var e = "";

        if (
            m.expires &&
            (typeof m.expires == "number" || m.expires.toUTCString)
        ) {
            var f;

            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(
                    f.getTime() +
                    m.expires * 24 * 60 * 60 * 1000
                );
            } else {
                f = m.expires;
            }

            e = "; expires=" + f.toUTCString();
        }

        var l = m.path ? "; path=" + m.path : "";
        var g = m.domain ? "; domain=" + m.domain : "";
        var a = m.secure ? "; secure" : "";

        document.cookie = [
            b,
            "=",
            encodeURIComponent(j),
            e,
            l,
            g,
            a
        ].join("");
    } else {
        var d = null;

        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");

            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);

                if (
                    c.substring(0, b.length + 1) ==
                    b + "="
                ) {
                    d = decodeURIComponent(
                        c.substring(b.length + 1)
                    );
                    break;
                }
            }
        }

        return d;
    }
};

/**
 * Recently Viewed Products
 */

Shopify.Products = (function () {
    console.info(
        "[Sydfisk] Recently viewed redirect guard v2 loaded"
    );

    var config = {
        howManyToShow: 3,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        layout: "slider",
        swipe: true,
        media: "adapt",
        onComplete: null
    };

    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
    var shownSection = 0;

    var cookie = {
        configuration: {
            expires: 90,
            path: "/",
            domain: window.location.hostname
        },

        name: "shopify_recently_viewed",

        write: function (recentlyViewed) {
            var value = recentlyViewed.join(" ");

            jQuery.cookie(
                this.name,
                value,
                this.configuration
            );

            localStorage.setItem(this.name, value);
        },

        read: function () {
            var recentlyViewed = [];
            var cookieValue = jQuery.cookie(this.name);

            if (Shopify.designMode && !cookieValue) {
                cookieValue = localStorage.getItem(
                    this.name
                );
            }

            if (
                cookieValue !== null &&
                cookieValue !== ""
            ) {
                recentlyViewed = cookieValue.split(" ");
            }

            return recentlyViewed;
        },

        destroy: function () {
            jQuery.cookie(
                this.name,
                null,
                this.configuration
            );

            localStorage.removeItem(this.name);
        },

        remove: function (productHandle) {
            var recentlyViewed = this.read();

            var position = jQuery.inArray(
                productHandle,
                recentlyViewed
            );

            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    /**
     * Kontrollerar att AJAX-svaret:
     *
     * 1. Inte har redirectats till en annan URL
     * 2. Inte är en komplett HTML-sida
     * 3. Består av ett produktkort
     */
    var isValidSectionProductResponse = function (
        response,
        requestedUrl,
        finalUrl
    ) {
        if (
            typeof response !== "string" ||
            response.trim() === ""
        ) {
            return false;
        }

        var requestedPath = new URL(
            requestedUrl,
            window.location.origin
        )
            .pathname
            .replace(/\/$/, "");

        var resolvedPath = new URL(
            finalUrl || requestedUrl,
            window.location.origin
        )
            .pathname
            .replace(/\/$/, "");

        /**
         * Exempel:
         *
         * Begärd:
         * /products/hamta-sjalv-i-arlov
         *
         * Slutlig efter redirect:
         * /collections/grossist
         *
         * Då ska svaret stoppas.
         */
        if (resolvedPath !== requestedPath) {
            return false;
        }

        var looksLikeFullPage =
            /<!doctype/i.test(response) ||
            /<html(?:\s|>)/i.test(response) ||
            /<head(?:\s|>)/i.test(response) ||
            /<body(?:\s|>)/i.test(response);

        if (looksLikeFullPage) {
            return false;
        }

        var container =
            document.createElement("div");

        container.innerHTML = response.trim();

        var firstElement =
            container.firstElementChild;

        var hasExactlyOneRootElement =
            container.children.length === 1;

        var isExpectedProductWrapper =
            firstElement &&
            firstElement.classList.contains(
                "product"
            ) &&
            firstElement.querySelector(
                ".product-item"
            );

        var containsPageChrome =
            container.querySelector(
                [
                    "html",
                    "head",
                    "body",
                    "header",
                    "footer",
                    "main",
                    "script",
                    "#shopify-section-header",
                    "#shopify-section-footer",
                    ".collection-default"
                ].join(", ")
            );

        return Boolean(
            hasExactlyOneRootElement &&
            isExpectedProductWrapper &&
            !containsPageChrome
        );
    };

    var finalize = function () {
        var items = wrapper.find(".item");

        if (items.length <= 2) {
            $("#recently-viewed-products-list")
                .addClass("center");
        }

        $("#recently-viewed-products-list-2")
            .addClass("recently-viewed-loaded");

        wrapper.show();

        if (config.onComplete) {
            try {
                config.onComplete();
            } catch (error) {
                console.error(
                    "Recently viewed onComplete error:",
                    error
                );
            }
        }
    };

    /**
     * Popupversionen av nyligen visade
     */
    var moveAlong = function (wrapperP) {
        if (
            productHandleQueue.length &&
            shown < config.howManyToShow
        ) {
            var handle =
                productHandleQueue[shown];

            var url =
                window.routes.root +
                "/products/" +
                handle +
                "?view=ajax_recently_viewed";

            jQuery.ajax({
                type: "get",
                url: url,
                cache: false,

                success: function (product) {
                    if (handle !== "") {
                        wrapperP.append(product);
                    }

                    shown++;
                    moveAlong(wrapperP);
                },

                error: function (xhr) {
                    console.warn(
                        "Recently viewed popup: AJAX request failed.",
                        {
                            handle: handle,
                            status: xhr
                                ? xhr.status
                                : null
                        }
                    );

                    cookie.remove(handle);

                    shown++;
                    moveAlong(wrapperP);
                }
            });
        } else {
            finalize();
        }
    };

    /**
     * Nyligen visade-sektionen
     */
    var doAlong = function (wrapperS) {
        const recentlyViewed = wrapperS.parents(
            ".halo-recently-viewed-block"
        );

        const sectionId =
            recentlyViewed.attr("sectionid");

        if (
            productHandleQueue.length &&
            shownSection < config.howManyToShow
        ) {
            var handle =
                productHandleQueue[shownSection];

            var url =
                window.routes.root +
                "/products/" +
                handle +
                "?view=ajax_section_recently_viewed";

            jQuery.ajax({
                type: "get",
                url: url,
                cache: false,

                success: function (
                    product,
                    textStatus,
                    xhr
                ) {
                    var finalUrl =
                        xhr && xhr.responseURL
                            ? xhr.responseURL
                            : "";

                    var validResponse =
                        isValidSectionProductResponse(
                            product,
                            url,
                            finalUrl
                        );

                    if (
                        handle !== "" &&
                        validResponse
                    ) {
                        wrapperS.append(product);
                    } else {
                        console.warn(
                            "Recently viewed: redirected or invalid response skipped.",
                            {
                                handle: handle,
                                requestedUrl: url,
                                finalUrl: finalUrl
                            }
                        );

                        /**
                         * Tar bort den gamla produkten
                         * från cookie och localStorage.
                         */
                        cookie.remove(handle);
                    }

                    if (shownSection === 0) {
                        const productLoading =
                            wrapperS
                                .find(
                                    ".product-item--loadingNoInfo"
                                )
                                .parents(".product");

                        productLoading.remove();
                    }

                    shownSection++;
                    doAlong(wrapperS);

                    recentlyViewed
                        .find(
                            ".card .variants-popup-content .selector-wrapper .swatch-element"
                        )
                        .each(function () {
                            const $input =
                                $(this).find("input");

                            const $label =
                                $(this).find("label");

                            $input.attr({
                                id:
                                    ($input.attr("id") ||
                                        "") +
                                    sectionId,

                                name:
                                    ($input.attr(
                                        "name"
                                    ) || "") +
                                    sectionId
                            });

                            $label.attr(
                                "for",
                                ($label.attr("for") ||
                                    "") +
                                    sectionId
                            );
                        });

                    recentlyViewed
                        .find(".card")
                        .each(function () {
                            const $qsForm = $(this)
                                .find(
                                    ".variants-popup-content form"
                                );

                            const $acForm = $(this)
                                .find(
                                    ".card-action form"
                                );

                            const $select = $(this)
                                .find(
                                    ".variants-popup-content select"
                                );

                            const $acButton = $(this)
                                .find(
                                    ".card-action form button"
                                );

                            const $qsButton = $(this)
                                .find(
                                    ".variants-popup-content .product-card__button2 button"
                                );

                            $qsForm.attr(
                                "id",
                                ($qsForm.attr("id") ||
                                    "") +
                                    sectionId
                            );

                            $acForm.attr(
                                "id",
                                ($acForm.attr("id") ||
                                    "") +
                                    sectionId
                            );

                            $select.attr(
                                "id",
                                ($select.attr("id") ||
                                    "") +
                                    sectionId
                            );

                            $acButton.attr(
                                "data-form-id",
                                ($acButton.attr(
                                    "data-form-id"
                                ) || "") +
                                    sectionId
                            );

                            $qsButton.attr(
                                "data-form-id",
                                ($qsButton.attr(
                                    "data-form-id"
                                ) || "") +
                                    sectionId
                            );
                        });
                },

                error: function (xhr) {
                    console.warn(
                        "Recently viewed: AJAX request failed.",
                        {
                            handle: handle,
                            requestedUrl: url,
                            status: xhr
                                ? xhr.status
                                : null,
                            responseText: xhr
                                ? xhr.responseText
                                : null
                        }
                    );

                    cookie.remove(handle);

                    if (shownSection === 0) {
                        const productLoading =
                            wrapperS
                                .find(
                                    ".product-item--loadingNoInfo"
                                )
                                .parents(".product");

                        productLoading.remove();
                    }

                    shownSection++;
                    doAlong(wrapperS);
                }
            });
        } else {
            if (productHandleQueue.length === 0) {
                recentlyViewed.hide();
                return;
            }

            if (config.layout === "slider") {
                var productGrid = wrapperS;

                var itemToShow =
                    productGrid.data(
                        "item-to-show"
                    );

                var itemDots =
                    productGrid.data("item-dots");

                var itemDotsMb =
                    productGrid.data(
                        "item-dots-mb"
                    );

                var itemArrows =
                    productGrid.data(
                        "item-arrows"
                    );

                var itemArrowsMb =
                    productGrid.data(
                        "item-arrows-mb"
                    );

                if (productGrid.length > 0) {
                    if (
                        productGrid.not(
                            ".slick-initialized"
                        )
                    ) {
                        productGrid.slick({
                            mobileFirst: true,
                            adaptiveHeight: true,
                            vertical: false,
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: itemArrowsMb,
                            dots: itemDotsMb,
                            nextArrow:
                                window.arrows
                                    .icon_next,
                            prevArrow:
                                window.arrows
                                    .icon_prev,
                            rtl:
                                window.rtl_slick,

                            responsive: [
                                {
                                    breakpoint: 1599,

                                    settings: {
                                        arrows:
                                            itemArrows,

                                        dots:
                                            itemDots,

                                        get slidesToShow() {
                                            if (
                                                itemToShow !==
                                                    undefined &&
                                                itemToShow !==
                                                    null &&
                                                itemToShow !==
                                                    ""
                                            ) {
                                                return (
                                                    this
                                                        .slidesToShow =
                                                        itemToShow
                                                );
                                            }

                                            return (
                                                this
                                                    .slidesToShow =
                                                    1
                                            );
                                        },

                                        get slidesToScroll() {
                                            if (
                                                itemToShow !==
                                                    undefined &&
                                                itemToShow !==
                                                    null &&
                                                itemToShow !==
                                                    ""
                                            ) {
                                                return (
                                                    this
                                                        .slidesToScroll =
                                                        itemToShow
                                                );
                                            }

                                            return (
                                                this
                                                    .slidesToScroll =
                                                    1
                                            );
                                        }
                                    }
                                },

                                {
                                    breakpoint: 1024,

                                    settings: {
                                        arrows:
                                            itemArrows,

                                        dots:
                                            itemDots,

                                        get slidesToShow() {
                                            if (
                                                itemToShow !==
                                                    undefined &&
                                                itemToShow !==
                                                    null &&
                                                itemToShow !==
                                                    ""
                                            ) {
                                                if (
                                                    itemToShow ==
                                                    5
                                                ) {
                                                    return (
                                                        this
                                                            .slidesToShow =
                                                            itemToShow -
                                                            1
                                                    );
                                                }

                                                return (
                                                    this
                                                        .slidesToShow =
                                                        itemToShow
                                                );
                                            }

                                            return (
                                                this
                                                    .slidesToShow =
                                                    1
                                            );
                                        },

                                        get slidesToScroll() {
                                            if (
                                                itemToShow !==
                                                    undefined &&
                                                itemToShow !==
                                                    null &&
                                                itemToShow !==
                                                    ""
                                            ) {
                                                if (
                                                    itemToShow ==
                                                    5
                                                ) {
                                                    return (
                                                        this
                                                            .slidesToScroll =
                                                            itemToShow -
                                                            1
                                                    );
                                                }

                                                return (
                                                    this
                                                        .slidesToScroll =
                                                        itemToShow
                                                );
                                            }

                                            return (
                                                this
                                                    .slidesToScroll =
                                                    1
                                            );
                                        }
                                    }
                                },

                                {
                                    breakpoint: 991,

                                    settings: {
                                        arrows:
                                            itemArrowsMb,
                                        dots:
                                            itemDotsMb,
                                        slidesToShow: 4,
                                        slidesToScroll: 4
                                    }
                                },

                                {
                                    breakpoint: 767,

                                    settings: {
                                        arrows:
                                            itemArrowsMb,
                                        dots:
                                            itemDotsMb,
                                        slidesToShow: 3,
                                        slidesToScroll: 3
                                    }
                                },

                                {
                                    breakpoint: 320,

                                    settings: {
                                        arrows:
                                            itemArrowsMb,
                                        dots:
                                            itemDotsMb,
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                }
                            ]
                        });
                    }
                }

                if (
                    $("body").hasClass(
                        "cursor-fixed__show"
                    )
                ) {
                    if (
                        window
                            .sharedFunctionsAnimation
                    ) {
                        window
                            .sharedFunctionsAnimation
                            .onEnterButton();

                        window
                            .sharedFunctionsAnimation
                            .onLeaveButton();
                    }
                }
            }

            if (
                $("body").hasClass(
                    "product-card-layout-08"
                )
            ) {
                window.sharedFunctions
                    ?.productCountdownCard();
            }

            window.sharedFunctions
                ?.swapHoverVideoProductCard();
        }
    };

    return {
        resizeImage: function (src, size) {
            if (size == null) {
                return src;
            }

            if (size == "master") {
                return src.replace(
                    /http(s)?:/,
                    ""
                );
            }

            var match = src.match(
                /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i
            );

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return (
                    prefix[0] +
                    "_" +
                    size +
                    suffix
                ).replace(/http(s)?:/, "");
            }

            return null;
        },

        showRecentlyViewed: function (params) {
            params = params || {};

            jQuery.extend(config, params);

            productHandleQueue =
                cookie.read();

            template = config.templateId;

            wrapper = jQuery(
                "#" + config.wrapperId
            );

            shown = 0;
            shownSection = 0;

            config.howManyToShow =
                Math.min(
                    productHandleQueue.length,
                    config.howManyToShow
                );

            if (
                config.howManyToShow &&
                wrapper.length
            ) {
                if (
                    template ===
                    "recently-viewed-product-popup"
                ) {
                    moveAlong(wrapper);
                } else {
                    doAlong(wrapper);
                }
            }
        },

        getConfig: function () {
            return config;
        },

        clearList: function () {
            cookie.destroy();
        },

        recordRecentlyViewed: function (
            params
        ) {
            params = params || {};

            jQuery.extend(config, params);

            var recentlyViewed =
                cookie.read();

            if (
                window.location.pathname.indexOf(
                    "/products/"
                ) !== -1
            ) {
                var splitted =
                    window.location.pathname.match(
                        /\/products\/([a-z0-9\-_]+)/
                    );

                var productHandle;

                if (splitted == null) {
                    productHandle =
                        decodeURIComponent(
                            window.location.pathname.split(
                                "/products/"
                            )[1]
                        );
                } else {
                    productHandle =
                        splitted[1];
                }

                var position =
                    jQuery.inArray(
                        productHandle,
                        recentlyViewed
                    );

                if (position === -1) {
                    recentlyViewed.unshift(
                        productHandle
                    );

                    recentlyViewed =
                        recentlyViewed.splice(
                            0,
                            config
                                .howManyToStoreInMemory
                        );
                } else {
                    recentlyViewed.splice(
                        position,
                        1
                    );

                    recentlyViewed.unshift(
                        productHandle
                    );
                }

                cookie.write(
                    recentlyViewed
                );
            }
        }
    };
})();